import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    children: [
      {
        path: "/mymessage",
        name: "mymessage",
        component: () =>
          import( "../views/MyMessage.vue"),
      },
      {
        path: "/uploadmusic",
        name: "uploadmusic",
        component: () =>
          import( "../views/uploadmusic.vue"),
      },
      {
        path: "/myupload",
        name: "myupload",
        component: () =>
          import( "../views/MyUpload.vue"),
      },
      {
        path: "/remittance",
        name: "remittance",
        component: () =>
          import( "../views/Remittance.vue"),
      },
    ],
  },
  

  {
    path: "/login",
    name: "login",
    component: () =>
      import( "../views/login.vue"),
  },
];

const router = new VueRouter({
  routes,
});


router.beforeEach((to,from,next)=>{
  let token =sessionStorage.getItem('token')
  if (token) {
    if (to.path!='/login') {
      next()
    }else{
      next('/')
    }
  }else{
      if (to.path!='/login') {
        next('/login')
      }else{
        next()
      }
  }
})
export default router;
